<app-modal-layout
    *transloco="let tUserSettings; read: 'user_settings'"
    [containerLayout]="containerLayout"
    (closeModal)="close()"
    [noXPadding]="true"
    [noYPadding]="true"
>
    @if (containerLayout !== ModalContainer.BottomSheet) {
        <div
            class="flex items-center p-4 sm:py-2 sm:bg-text text-primaryDark sm:text-inverted text-xl sm:body-1"
        >
            <div
                class="flex items-center justify-center w-5 h-5 rounded-full mr-2 body-1 text-inverted bg-primary"
            >
                {{ solutionIcon }}
            </div>
            <div>{{ solutionName }}</div>
        </div>
    } @else {
        <ng-container title
            ><span class="max-md:text-text">{{ solutionName }}</span></ng-container
        >
    }
    <div class="flex flex-col md:p-4 px-0 py-1">
        <app-tb-menu-list-item class="mb-2" icon="logout" (click)="logout()">
            {{ tUserSettings('log_out') }}
        </app-tb-menu-list-item>
        <app-tb-divider class="mb-2"></app-tb-divider>
        <div
            class="flex mb-2 body-1 items-center cursor-pointer pr-2 py-1 pl-1 min-size-menu-item rounded hover:bg-neutral3"
        >
            <app-version class="w-full h-5"></app-version>
        </div>
        <app-tb-menu-list-item icon="refresh" (click)="resetSolution()" class="mb-2">
            {{ tUserSettings('reset_solution') }}
        </app-tb-menu-list-item>
        @if (envIsMock()) {
            <app-tb-select
                [value]="devDefaultSolutionValue"
                (selectionChange)="devSolutionChanged($event)"
            >
                @for (type of devSolutionTypes; track type) {
                    <app-tb-option [value]="type"> {{ type }}</app-tb-option>
                }
            </app-tb-select>
        }
        @if (envIsMock() || envIsDev()) {
            <app-tb-select
                [value]="devCurrentEnvMode$ | async"
                [placeholder]="(devCurrentEnvMode$ | async) || ''"
                (selectionChange)="devSetEnvMode($event)"
            >
                @for (mode of devEnvModesOptions; track mode) {
                    <app-tb-option [value]="mode"> {{ mode }}</app-tb-option>
                }
            </app-tb-select>
        }
        @if ((envIsMock() || envIsDev()) && devPublicDocsMenuItems.length) {
            <app-tb-divider class="my-2"></app-tb-divider>
            @for (publicDocsMenuItem of devPublicDocsMenuItems; track publicDocsMenuItem.section) {
                <app-tb-menu-list-item
                    class="mb-2 last:mb-0"
                    [icon]="publicDocsMenuItem.icon"
                    (click)="navigateToPublicDocs(publicDocsMenuItem.section)"
                >
                    {{ publicDocsMenuItem.label }}
                </app-tb-menu-list-item>
            }
        }
    </div>
</app-modal-layout>
